/*
 * @Author: cws
 * @Date: 2022-10-08 15:03:01
 * @LastEditors: cws
 * @LastEditTime: 2022-10-10 11:49:42
 * @Description: 评估项目详情service
 */

import axios from 'axios';
import config from '@/config';
import { pgxmManageService } from '../pgxm.service';

const { iffApi } = config.ctx; ;

export const pgxmDetailsService = {
  pgyqQuery: (params) => { return axios.get(`${iffApi}/xfpg/pgyq`, { params: params }); },

  pgcyQuery: (id) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/pgcy`); },
  // 建筑信息列表查询
  jzxxQuery: (id, params) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/jzxx`, { params: params }); },

  pgxmActionInfo: (_xmId, _params) => { return axios.all([pgxmDetailsService.pgcyQuery(_xmId), pgxmDetailsService.jzxxQuery(_xmId, _params)]); },

  pgPreloadInfo: (_xmId, _yqParams) => {
    return axios.all([pgxmDetailsService.pgyqQuery(_yqParams), pgxmManageService.pgyqByXmid(_xmId), pgxmManageService.gwwtListQuery(), pgxmManageService.gwwtXmQuery(_xmId)]);
  },

  // 申请修改
  sqxg: (params) => { return axios.post(`${iffApi}/xfpg/pgbg/sqxg`, params); }
};
